// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MechanicMenu_mechanic-menu__SOsBj {
  width: 300px;
  border: 1px solid #0000001a;
  border-radius: 10px;
  background-color: #fff;
  position: absolute;
  top: 6rem;
  right: -20rem;
  z-index: var(--z-mechanic-menu);
}

.MechanicMenu_mechanic-menu__header__qVfGz {
  margin-top: 0.6rem;
  margin-inline-end: 1.4rem;
  padding: 0 2.4rem 1rem 0;
  min-height: 6rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  border-bottom: 0.7px solid var(--gray);
}

.MechanicMenu_mechanic-menu__shop-name__PUbi5 {
  font-size: var(--text-base);
  font-weight: 700;
  line-height: 2.2rem;
  color: var(--primary-color);
}

.MechanicMenu_mechanic-menu__list__SDFrn {
  padding-inline: 1rem;
}

.MechanicMenu_mechanic-menu__list-item__72Q9C {
  height: 60px;
  padding-inline-start: 1.4rem;
  display: flex;
  align-items: center;
}

.MechanicMenu_mechanic-menu__list-item__72Q9C:first-child {
  justify-content: space-between;
}

.MechanicMenu_mechanic-menu__link__wdYGX {
  flex-grow: 1;
}

.MechanicMenu_mechanic-menu__list-item__72Q9C:first-child > .MechanicMenu_mechanic-menu__link__wdYGX {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.MechanicMenu_mechanic-menu__balance__airLQ {
  font-size: var(--text-lg);
  font-weight: 700;
  line-height: 3.1rem;
  padding-inline-end: 1.7rem;
  color: var(--primary-color);
}

.MechanicMenu_mechanic-menu__list-item__72Q9C:last-child {
  border-bottom: 0.7px solid var(--gray);
}

.MechanicMenu_mechanic-menu__logout__lnUKD {
  margin: 0.8rem 2.2rem 0.8rem 1rem;
  padding-inline-start: 1.4rem;
  height: 54px;
  display: flex;
  align-items: center;
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .MechanicMenu_mechanic-menu__SOsBj {
    width: 25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/DashboardHeader/MechanicMenu/MechanicMenu.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".mechanic-menu {\n  width: 300px;\n  border: 1px solid #0000001a;\n  border-radius: 10px;\n  background-color: #fff;\n  position: absolute;\n  top: 6rem;\n  right: -20rem;\n  z-index: var(--z-mechanic-menu);\n}\n\n.mechanic-menu__header {\n  margin-top: 0.6rem;\n  margin-inline-end: 1.4rem;\n  padding: 0 2.4rem 1rem 0;\n  min-height: 6rem;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 1rem;\n  border-bottom: 0.7px solid var(--gray);\n}\n\n.mechanic-menu__shop-name {\n  font-size: var(--text-base);\n  font-weight: 700;\n  line-height: 2.2rem;\n  color: var(--primary-color);\n}\n\n.mechanic-menu__list {\n  padding-inline: 1rem;\n}\n\n.mechanic-menu__list-item {\n  height: 60px;\n  padding-inline-start: 1.4rem;\n  display: flex;\n  align-items: center;\n}\n\n.mechanic-menu__list-item:first-child {\n  justify-content: space-between;\n}\n\n.mechanic-menu__link {\n  flex-grow: 1;\n}\n\n.mechanic-menu__list-item:first-child > .mechanic-menu__link {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.mechanic-menu__balance {\n  font-size: var(--text-lg);\n  font-weight: 700;\n  line-height: 3.1rem;\n  padding-inline-end: 1.7rem;\n  color: var(--primary-color);\n}\n\n.mechanic-menu__list-item:last-child {\n  border-bottom: 0.7px solid var(--gray);\n}\n\n.mechanic-menu__logout {\n  margin: 0.8rem 2.2rem 0.8rem 1rem;\n  padding-inline-start: 1.4rem;\n  height: 54px;\n  display: flex;\n  align-items: center;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .mechanic-menu {\n    width: 25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mechanic-menu": `MechanicMenu_mechanic-menu__SOsBj`,
	"mechanic-menu__header": `MechanicMenu_mechanic-menu__header__qVfGz`,
	"mechanic-menu__shop-name": `MechanicMenu_mechanic-menu__shop-name__PUbi5`,
	"mechanic-menu__list": `MechanicMenu_mechanic-menu__list__SDFrn`,
	"mechanic-menu__list-item": `MechanicMenu_mechanic-menu__list-item__72Q9C`,
	"mechanic-menu__link": `MechanicMenu_mechanic-menu__link__wdYGX`,
	"mechanic-menu__balance": `MechanicMenu_mechanic-menu__balance__airLQ`,
	"mechanic-menu__logout": `MechanicMenu_mechanic-menu__logout__lnUKD`
};
export default ___CSS_LOADER_EXPORT___;
